import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import apiCalls from '../../utils/apiCalls';
import utils from '../../utils/utils';
import { injectIntl } from 'react-intl';

const AdminPayoutReportRow = ({ payoutReport, intl, selectPayoutReport, isSelected, refetch }) => {
  function deletePayoutReport() {
    const confirmMessage = intl.formatMessage({ id: 'payout.report.delete.confirm' });

    if (window.confirm(confirmMessage)) {
      apiCalls
        .deletePayoutReport(payoutReport.id)
        .then(refetch)
        .catch((errors) => {
          window.alert(utils.getErrorMessageFromResponse(errors, true));
        });
    }
  }

  function setPayoutReportStatus() {
    const newReport = Object.assign({}, payoutReport);
    newReport.status = 'PAID';
    return apiCalls
      .editPayoutReport({ payoutReport: newReport })
      .then(refetch)
      .catch((error) => {
        window.alert(utils.getErrorMessageFromResponse(error, true));
        window.scrollTo(0, 0);
      });
  }

  return (
    <tr>
      <th scope="row">
        <Link to={`/admin/payoutReport/${payoutReport.id}`} className="link">
          {payoutReport.id}
        </Link>
      </th>
      <td>
        <div>{payoutReport.marketplace.name}</div>
        <div className="text-small">{payoutReport.recipientName}</div>
      </td>
      <td>{payoutReport.amount}€</td>
      <td>
        {payoutReport.status === 'PAID' ? '✅ ' : ''}
        {payoutReport.status}
      </td>
      <td>{payoutReport.commission}€</td>
      <td>
        <div className="form-group m-b-2">
          <div className="checkbox">
            <label>
              <input type="checkbox" checked={isSelected} onChange={selectPayoutReport} /> Select
            </label>
          </div>
        </div>
        <Link
          to={`/marketplaceAdmin/${payoutReport.marketplace.id}/payoutReports/view/${payoutReport.id}`}
          className="link"
        >
          View
        </Link>
        <br />
        <button className="btn btn-normal-link" onClick={setPayoutReportStatus}>
          Mark PAID
        </button>
        <br />
        <button className="btn btn-normal-link" onClick={deletePayoutReport}>
          Delete
        </button>
        <br />
      </td>
    </tr>
  );
};

AdminPayoutReportRow.propTypes = {
  payoutReport: PropTypes.object.isRequired,
  refetch: PropTypes.func.isRequired,
  selectPayoutReport: PropTypes.func.isRequired,
};

export default injectIntl(AdminPayoutReportRow);
